/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeetDayStudent } from '../../models/meet-day-student';

export interface UpdateMeetDayStudent$Params {
  meetDayId: string;
  id: string;
      body?: MeetDayStudent
}

export function updateMeetDayStudent(http: HttpClient, rootUrl: string, params: UpdateMeetDayStudent$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDayStudent>> {
  const rb = new RequestBuilder(rootUrl, updateMeetDayStudent.PATH, 'put');
  if (params) {
    rb.path('meetDayId', params.meetDayId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MeetDayStudent>;
    })
  );
}

updateMeetDayStudent.PATH = '/meetday/{meetDayId}/student/{id}';
